import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.7; transform: scale(1.1); }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
`;

const SpinnerRing = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid rgba(220, 38, 38, 0.2);
  border-top: 4px solid #DC2626;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 1rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 30px;
    height: 30px;
    background: linear-gradient(45deg, #DC2626, #EF4444);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    animation: ${pulse} 2s ease-in-out infinite;
  }
`;

const LoadingText = styled.p`
  color: #374151;
  font-weight: 500;
  animation: ${float} 2s ease-in-out infinite;
  margin: 0;
`;

const SkeletonCard = styled.div`
  width: 100%;
  height: 200px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0.1) 100%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 16px;
  margin-bottom: 1rem;
`;

interface LoadingSpinnerProps {
  text?: string;
  variant?: 'spinner' | 'skeleton';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  text = 'Loading delicious content...', 
  variant = 'spinner' 
}) => {
  if (variant === 'skeleton') {
    return (
      <div>
        {[...Array(3)].map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  return (
    <LoadingContainer>
      <SpinnerRing />
      <LoadingText>{text}</LoadingText>
    </LoadingContainer>
  );
};

export default LoadingSpinner; 